import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { CmElement, ContentType } from '../shared/model/cm/managed-content.model';
import { LevelTwoQuestion } from '../shared/model/ui/level-two-question';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AdditionalDetailsComponent } from '../additional-details/additional-details.component';

@Component({
  selector: 'app-chronic-acute',
  standalone: true,
  imports: [ReactiveFormsModule, forwardRef(() => AdditionalDetailsComponent)],
  templateUrl: './chronic-acute.component.html',
  styleUrls: ['./chronic-acute.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChronicAcuteComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() key: string;
  @Input() levelTwoQuestion: LevelTwoQuestion;

  chronicAcuteForm: UntypedFormGroup;
  public controlName: string;

  requiredElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'required-error');
  chronicAcuteContentError: string = this.requiredElement?.error;

  public chronicAcuteRadioButtonOptions = [
    { name: 'chronic', label: 'Chronic' },
    { name: 'acute', label: 'Acute' }
  ];

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService) { }

  ngOnInit(): void {
    
    this.controlName = this.key + "-condition";
    
    this.chronicAcuteForm = new UntypedFormGroup({ });
    
    if (this.parentForm) {
      // Check if parent already has this control (from restoration)
      let control = this.parentForm.get(this.controlName);
      
      if (!control) {
        // Control doesn't exist yet - create new one
        control = this.fb.control('', [Validators.required]);
        this.parentForm.addControl(this.controlName, control);
      }
      
      // Add the SAME control reference to local form so UI bindings work
      this.chronicAcuteForm.addControl(this.controlName, control);
    } else {
      // No parent form - create control only in local form
      this.chronicAcuteForm.addControl(this.controlName, this.fb.control('', [Validators.required]));
    }
  }

  logRadioChangeEvent(key: string, controlName: string){
    // Update both the local form and parent form with the selected value
    if(this.chronicAcuteForm && this.chronicAcuteForm.contains(this.controlName)){
      this.chronicAcuteForm.get(this.controlName).setValue(controlName);
    }
    if(this.parentForm && this.parentForm.contains(this.controlName)){
      this.parentForm.get(this.controlName).setValue(controlName);
    }
  }
}